import { Currency } from '../enums/currency.enum';
import { CurrencyListItem } from '../interfaces/currency.interfaces';

export const convertCurrencyToSign = (currency: Currency) => currencySignMapping[currency];
export const convertUnsupportedCurrencyToText = (currency: Currency) => unsupportedCurrencySignMapping[currency];

const unsupportedCurrencySignMapping = {
  ILS: 'NIS',
};

const currencySignMapping = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  ILS: '₪',
  AFN: '؋',
  ALL: 'Lek',
  ARS: '$',
  AWG: 'ƒ',
  AUD: '$',
  AZN: '₼',
  BSD: '$',
  BHD: 'BD',
  BBD: '$',
  BYN: 'Br',
  BZD: 'BZ$',
  BMD: '$',
  BOB: '$b',
  BAM: 'KM',
  BWP: 'P',
  BRL: 'R$',
  BND: '$',
  BGN: 'лв',
  KHR: '៛',
  CAD: 'C$',
  KYD: '$',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  HRK: 'kn',
  CUP: '₱',
  CZK: 'Kč',
  DKK: 'kr',
  DOP: 'RD$',
  XCD: '$',
  EGP: '£',
  SVC: '$',
  FKP: '£',
  FJD: '$',
  GHS: '¢',
  GIP: '£',
  GTQ: 'Q',
  GGP: '£',
  GYD: '$',
  HNL: 'L',
  HKD: '$',
  HUF: 'Ft',
  ISK: 'kr',
  INR: '₹',
  IDR: 'Rp',
  IRR: '﷼',
  IMP: '£',
  JMD: 'J$',
  JPY: '¥',
  JEP: '£',
  JOD: 'د.أ',
  KZT: 'лв',
  KES: 'K',
  KWD: 'د.ك',
  KGS: 'лв',
  LAK: '₭',
  LBP: '£',
  LRD: '$',
  MKD: 'ден',
  MYR: 'RM',
  MUR: '₨',
  MXN: '$',
  MNT: '₮',
  MZN: 'MT',
  NAD: '$',
  NPR: '₨,',
  ANG: 'ƒ',
  NZD: '$',
  NIO: 'C$',
  NOK: 'kr',
  OMR: 'ر.ع',
  PEN: 'S/',
  PHP: '₱',
  PLN: 'zł',
  QAR: '﷼',
  RON: 'L',
  RUB: '₽',
  SAR: '﷼',
  RSD: 'Дин.',
  SCR: '₨,',
  SGD: 'S$',
  ZAR: 'R',
  KRW: '₩',
  LKR: 'Rs',
  SEK: 'kr,',
  CHF: 'CHF',
  SYP: '£',
  TWD: 'NT$',
  THB: '฿',
  TTD: 'TT$,',
  TRY: '₺',
  AED: 'د.إ',
  UYU: '$U',
  VND: '₫',
  YER: '﷼',
  ZWD: 'Z$',
};

export const currencyList: CurrencyListItem[] = [
  {
    flag: '🇺🇸',
    currency: Currency.USD,
    currencySymbol: currencySignMapping.USD,
  },
  {
    flag: '🇪🇺',
    currency: Currency.EUR,
    currencySymbol: currencySignMapping.EUR,
  },
  {
    flag: '🇬🇧',
    currency: Currency.GBP,
    currencySymbol: currencySignMapping.GBP,
  },
  {
    flag: '🇮🇱',
    currency: Currency.ILS,
    currencySymbol: currencySignMapping.ILS,
  },
];
